import axiosInstance from "../instance";

// Get All Categories
const fetchDeliveryTypes = async () => {
    const response = await axiosInstance.get('/delivery-types');
    return response.data;
}

const addDeliveryType = async (newDeliveryType) => {
    const response = await axiosInstance.post('/delivery-types', newDeliveryType);
    return response.data;
}

const updateDeliveryType = async (newDeliveryType) => {
    const response = await axiosInstance.patch(`/delivery-types/${newDeliveryType.deliveryTypeId}`, {
        type: newDeliveryType.type,
        time: newDeliveryType.time,
        price: newDeliveryType.price
    });
    return response.data;
}

const deleteDeliveryType = async (deliveryTypeId) => {
    const response = await axiosInstance.delete(`/delivery-types/${deliveryTypeId}`);
    return response.data;
}

export { fetchDeliveryTypes, addDeliveryType, updateDeliveryType, deleteDeliveryType };
